import {
  Button,
  Card,
  Divider,
  Grid,
  Snackbar,
  Table,
  TableBody,
  TableHead,
  Typography,
  IconButton,
  Alert as MuiAlert,
  Pagination,
  CardContent,
  TableContainer,
  TextField,
  Box
} from '@mui/material'
import {
  Add as AddIcon,
  Edit as EditIcon,
  Visibility as VisibilityIcon
} from '@mui/icons-material'
import { useEffect, useState, forwardRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { businessCheck } from '../../utils/utils'
import PlanDrawer from './host/planDrawer'
import PlanInfoDrawer from './host/planInfoDrawer'
import {
  SnackBarHideDuration,
  StyledTableCell,
  StyledTableRow,
  SnackBarTransition
} from '../../utils/ui_utils'
import moment from 'moment'
import {
  usePlanCreate,
  usePlanFetch,
  usePlanUpdate
} from '../../modules/plans/planHooks'
import { useApplicationFetch } from '../../modules/application/applicationHooks'
import {
  useFetchModuleInApplication,
  useModuleFetch
} from '../../modules/modules/modulesHooks'

function PayPerUserPlan() {
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(20)
  const [pagecount, setPageCount] = useState(1)
  const [goToPageInput, setGoToPageInput] = useState('')
  const [planData, setPlanData] = useState(undefined)

  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const [planDrawerVisibility, setPlanDrawerVisibility] = useState(false)
  const [planInfoDrawerVisibility, setPlanInfoDrawerVisibility] =
    useState(false)
  const [planDrawerMode, setPlanDrawerMode] = useState('edit')
  const { fetchPlan, fetchPlanData, fetchPlanError, fetchPlanLoading } =
    usePlanFetch()
  const { createPlan, createPlanData, createPlanError, createPlanLoading } =
    usePlanCreate()
  const { updatePlan, updatePlanData, updatePlanError, updatePlanLoading } =
    usePlanUpdate()
  const { applicationFetch, loading, error, data } = useApplicationFetch()
  const {
    moduleInApplicationFetch,
    moduleInApplicationFetchData,
    moduleInApplicationFetchError,
    moduleInApplicationFetchLoading
  } = useFetchModuleInApplication()

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }
  const handlePageChange = async (event, value) => {
    setPage(value)
    let payload = {
      pageNumber: value,
      limit: limit
    }
    fetchPlan(payload)
  }

  const handleGoToPageChange = (event) => {
    const value = event.target.value
    if (/^\d+$/.test(value) || value === '') {
      setGoToPageInput(value)
    }
  }

  const handleGoToPageSubmit = () => {
    const pageNum = parseInt(goToPageInput, 10)
    if (pageNum >= 1 && pageNum <= pagecount) {
      handlePageChange(null, pageNum)
      setGoToPageInput('')
    }
  }

  const handleGoToPageKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmit()
    }
  }

  const pageCount = (data1) => {
    let count = Math.ceil(data1 / limit)
    setPageCount(count)
  }

  const history = useNavigate()

  useEffect(() => {
    businessCheck(history)
    let payload = {
      pageNumber: page,
      limit: limit
    }
    fetchPlan(payload)
    payload.limit = 100
    applicationFetch(payload)
  }, [])

  const onEditClickPlan = async (plan) => {
    let payload = {
      application_id: plan?.application?._id,
      pageNumber: 1,
      limit: 50
    }
    await moduleInApplicationFetch(payload)
  }

  function ModulesInPlanInfo() {
    if (
      fetchPlanData?.modules?.length !== undefined &&
      fetchPlanData?.modules?.length !== 0
    ) {
      return (
        <Grid container>
          <Grid item xs={6} md={7} lg={5}>
            <Card>
              <CardContent sx={{ flexGrow: 1 }}>
                <TableContainer component={Card}>
                  <Table size="small">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell align="center">
                          Module Name
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {fetchPlanData?.modules.map((row) => (
                        <StyledTableRow key={row._id}>
                          <StyledTableCell
                            align="center"
                            component="th"
                            scope="row"
                          >
                            {row.module_name}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )
    } else return <></>
  }

  if (error) return <p>Error!</p>
  if (loading) return <p>Loading...</p>
  return (
    <>
      <Helmet title="PayPerUserPlan" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item xs={5} md={6}>
          <Typography variant="h6" gutterBottom display="inline">
            Subscription Plans
          </Typography>
        </Grid>
        <Grid item>
          <Button
            startIcon={<AddIcon />}
            variant="contained"
            size="small"
            color="primary"
            onClick={() => {
              setPlanDrawerVisibility(true)
              setPlanData(undefined)
              setPlanDrawerMode('new')
            }}
          >
            Create Plan
          </Button>
          <PlanDrawer
            visible={planDrawerVisibility}
            okText={planDrawerMode == 'new' ? 'Create' : 'Update'}
            onSubmit={async (value) => {
              let values = _.cloneDeep(value)
              if (planDrawerMode == 'new') {
                let module = []
                for (let i = 0; i < values?.modules?.length; i++) {
                  let _id = values.modules[i]?._id
                  delete values.modules[i]
                  module.push(BigInt(_id))
                }
                values.modules = module
                values.application_id = BigInt(values.application_id)
                delete values.application

                await createPlan(values, (success, error) => {
                  if (error) {
                    toastMessage('Plan creation failed', 'error')
                  } else {
                    toastMessage('Plan created', 'success')
                    let payload = {
                      pageNumber: page,
                      limit: limit
                    }
                    fetchPlan(payload)
                    setPlanDrawerVisibility(false)
                  }
                })

                // plansAPI.create.api(values, (success, error) => {
                //   if (error) {
                //     toastMessage("Plan creation failed", "error")

                //   }
                //   else {
                //     toastMessage("Plan creaded", "success")
                //     plansAPI.fetch.api(page, limit);
                //     setPlanDrawerVisibility(false)
                //   }
                // })
              } else {
                let module = []
                for (let i = 0; i < values?.modules?.length; i++) {
                  let _id = values.modules[i]?._id
                  delete values.modules[i]
                  module.push(BigInt(_id))
                }
                values.modules = module
                values.application_id = values?.application?._id
                values.id = BigInt(values?._id)
                delete values.application
                delete values._id
                delete values.key

                await updatePlan(values, (success, error) => {
                  if (error) {
                    toastMessage('Plan update failed', 'error')
                  } else {
                    toastMessage('Plan updated', 'success')
                    let payload = {
                      pageNumber: page,
                      limit: limit
                    }
                    fetchPlan(payload)
                    setPlanDrawerVisibility(false)
                  }
                })

                // plansAPI.update.api(values, (success, error) => {
                //   if (error) {
                //     toastMessage("Plan update failed", "error")

                //   }
                //   else {
                //     toastMessage("Plan updated", "success")
                //     plansAPI.fetch.api(page, limit);
                //     setPlanDrawerVisibility(false)
                //   }
                // })
              }
            }}
            onCancel={() => setPlanDrawerVisibility(false)}
            title={
              planDrawerMode == 'new'
                ? 'Create New Subscription Plan'
                : 'Edit Subscription Plan'
            }
            initialValues={planData}
            applicationData={data}
            modulesData={moduleInApplicationFetchData}
            onApplicationChange={(value) => {
              let payload = {
                application_id: value,
                pageNumber: 1,
                limit: 50
              }
              moduleInApplicationFetch(payload)
            }}
            action={planDrawerMode}
          />
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: 5 }} />
      <Grid container spacing={10} sx={{ paddingTop: 5 }}>
        <Grid item>
          <Card raised sx={{ borderRadius: 3 }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <TableContainer component={Card}>
                <Table size="small">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>Name</StyledTableCell>
                      <StyledTableCell align="left">
                        {' '}
                        Application Name
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {' '}
                        Price Per User
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {' '}
                        Fixed Price
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {' '}
                        Free Users
                      </StyledTableCell>
                      <StyledTableCell align="left">Max Users</StyledTableCell>
                      <StyledTableCell align="left">
                        Plan Duration
                      </StyledTableCell>
                      <StyledTableCell align="left">Expiry</StyledTableCell>
                      <StyledTableCell align="left">Trial Plan</StyledTableCell>
                      <StyledTableCell align="center">Edit</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {fetchPlanData.map((row, i) => (
                      <StyledTableRow
                        key={i}
                        hover
                        onClick={() => setPlanData(row)}
                      >
                        <StyledTableCell component="th" scope="row">
                          {row.name}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row?.application?.application_name}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.price_per_user}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.fixed_charge}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.free_users}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.max_users}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.plan_duration}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {moment(new Date(row.expiry)).format('DD-MM-YYYY')}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.trial_plan ? 'Yes' : 'No'}
                        </StyledTableCell>
                        <StyledTableCell>
                          <IconButton
                            size="small"
                            color="primary"
                            component="span"
                            onClick={() => {
                              setPlanDrawerMode('edit')
                              setPlanDrawerVisibility(true)
                              onEditClickPlan(row)
                              setPlanData(row)
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            color="primary"
                            component="span"
                            onClick={() => {
                              setPlanInfoDrawerVisibility(true)
                              setPlanData(row)
                            }}
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
            {pagecount > 1 && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  p: 2,
                  backgroundColor: 'grey.50',
                  borderRadius: 1
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%'
                  }}
                >
                  <Pagination
                    count={pagecount}
                    page={page}
                    color="secondary"
                    size="small"
                    boundaryCount={2}
                    siblingCount={0}
                    showFirstButton
                    showLastButton
                    onChange={handlePageChange}
                    sx={{
                      '& .MuiPaginationItem-root': {
                        transition: 'all 0.2s ease-in-out'
                      }
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 1.5,
                    backgroundColor: 'white',
                    p: 2,
                    borderRadius: 1,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    transition: 'box-shadow 0.2s ease-in-out',
                    '&:hover': {
                      boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                    }
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary', fontWeight: 500 }}
                  >
                    Jump to
                  </Typography>
                  <TextField
                    size="small"
                    value={goToPageInput}
                    onChange={handleGoToPageChange}
                    onKeyPress={handleGoToPageKeyPress}
                    placeholder="Page"
                    sx={{
                      width: '80px',
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'white',
                        transition: 'all 0.2s ease-in-out',
                        '& fieldset': {
                          borderColor: 'grey.300',
                          borderWidth: '1px'
                        },
                        '&:hover fieldset': {
                          borderColor: 'secondary.main',
                          borderWidth: '1.5px'
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'secondary.main',
                          borderWidth: '2px',
                          boxShadow: '0 0 0 3px rgba(156, 39, 176, 0.1)'
                        }
                      },
                      '& .MuiOutlinedInput-input': {
                        textAlign: 'center',
                        fontWeight: 500,
                        padding: '7px 8px',
                        height: '20px',
                        lineHeight: '20px'
                      }
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary', fontWeight: 400 }}
                  >
                    of {pagecount}
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleGoToPageSubmit}
                    disabled={
                      !goToPageInput ||
                      parseInt(goToPageInput, 10) < 1 ||
                      parseInt(goToPageInput, 10) > pagecount
                    }
                    sx={{
                      textTransform: 'none',
                      fontWeight: 500,
                      px: 2,
                      py: 0.75,
                      height: '34px',
                      lineHeight: 1,
                      transition: 'all 0.2s ease-in-out',
                      '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow: '0 4px 8px rgba(156, 39, 176, 0.3)'
                      },
                      '&:active': {
                        transform: 'translateY(0)'
                      }
                    }}
                  >
                    Go
                  </Button>
                </Box>
              </Box>
            )}
          </Card>
        </Grid>
        <Grid item xs={6}>
          <ModulesInPlanInfo />
        </Grid>
      </Grid>

      <PlanInfoDrawer
        visible={planInfoDrawerVisibility}
        cancelText="Close"
        onClose={() => setPlanInfoDrawerVisibility(false)}
        initialValues={planData}
        title="Subscription Plan Info"
      />
      <div>
        <Snackbar
          open={snackbar}
          autoHideDuration={SnackBarHideDuration}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          TransitionComponent={SnackBarTransition}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {PopUpMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  )
}
export default PayPerUserPlan
